import { useEffect } from "react";

// Lightweight SEO helper — sets document title + meta description per page.
export default function SEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = `${title} | Winners Chapel Colchester`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
  return null;
}
